import React from 'react';
import {Grid, Paper, TextField, Typography} from "@material-ui/core";
import useStyles from "../../styles/styles";
import {Alert} from "@material-ui/lab";

/**
 * @typedef {HostedSideData} Person
 * @property {string} formId
 * @property {string} websiteName
 * @property {string} otpChoice
 * @property {number} otpAttempts
 * @property {number} otpVerified
 * @property {boolean} resumeResult
 * @property {boolean} isReturning
 * @property {boolean} returningDetected
 * @property {string} returningDisposition
 * @property {string} neoBankName
 * @property {string} neoBankChangeType
 * @property {string} routingNumberBankName
 * @property {string} neoBankRoutingNumberBankName
 * @property {string} neoBankRoutingNumberChangeType
 */

const HostedSiteInformation = ({
                                   loading,
                                   error,
                                   data
                               }) => {
    const classes = useStyles();

    if (error || !data) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left">Hosted Site Data</Typography>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }

    if ((!loading && !data) || data.formId === 0) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left">Hosted Site Data</Typography>
                <Paper className={classes.paper}>
                    <Alert severity="warning">Nothing to show.</Alert>
                </Paper>
            </>
        );
    }

    return (
        <>
            <Typography variant="h4" component="h4" align="left">Hosted Site Data</Typography>
            <Paper className={classes.paper}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8} lg={3}>
                        <TextField label="Form Id" value={data.formId} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={4} lg={2}>
                        <TextField label="Website Name" value={data.websiteName} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={8} md={4} lg={2}>
                        <TextField label="Otp Verified" value={data.otpVerified} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={8} md={4} lg={2}>
                        <TextField label="Otp Choice" value={data.otpChoice} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <TextField label="Otp Attempts" value={data.otpAttempts} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="Resume Result" value={data.resumeResult} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="Returning Detected" value={data.returningDetected} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="Returning Disposition" value={data.returningDisposition} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="Is Returning" value={data.isReturning} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="NeoBank Name" value={data.neoBankName} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="NeoBank Change Type" value={data.neoBankChangeType} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="Routing Number Bank Name" value={data.routingNumberBankName} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="NeoBank Routing Bank Name" value={data.neoBankRoutingNumberBankName} readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="NeoBank Routing Change type" value={data.neoBankRoutingNumberChangeType} readOnly fullWidth/>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
};

export default HostedSiteInformation
